import { AxiosRequestConfig, AxiosResponse } from "axios";
import { mySelfAuthHelper } from "../../../../utils/AuthUtils/AuthUtils";
import AxiosActions from "../../AxiosActions";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import { ImportCustomDataQueryKeys, ImportExportTypeKeys } from "../../../../views/privatePages/ImportAndExport/ImportAndExportTypes";

export const mySelf = (showSpinner?: boolean): Promise<AxiosResponse> => {
    return mySelfAuthHelper(showSpinner);
};

/**
 * @returns instead of MailingAddress API maps PracticeAddress in the same fields name
 */
export const getNpiList = (entityTypeCode: number, limit: number, page: number, searchText: string, spinner: boolean, config): Promise<AxiosResponse> => {
    return AxiosActions.get(
        getAxiosInstances().V2,
        `public/npi/list`, // ?entityTypeCode=${entityTypeCode}&limit=${limit}&page=${page}&searchText=${searchText}
        {
            withCredentials: false,
            params: {
                entityTypeCode,
                limit,
                page,
                searchText,
            },
            ...config,
        },
        spinner,
        false,
    );
};

export const getTemplateImportFile = (key: ImportExportTypeKeys, config: AxiosRequestConfig = {}, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/file/template/${key}/download`, config, spinner, false);
};

export const exportData = <T>(dto: T, queryKey: string, radioFilter: string): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/data/query-key/${queryKey}/export?${radioFilter}`, dto, { responseType: "blob" }, true);
};

export const importData = <T>(queryKey: string, formData: T) => {
    return AxiosActions.post(getAxiosInstances().V2, `/data/query-key/${queryKey}/import/start`, formData, {}, true);
};

export const importCustomData = <T>(queryKey: ImportCustomDataQueryKeys, formData: T) => {
    return AxiosActions.post(getAxiosInstances().V2, `/data/query-key/${queryKey}/custom-import/start`, formData, {}, true);
};

export const getAssumedIdentity = (id: number, config = {}): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/token/assume-identity/${id}`, { ...config, withCredentials: true }, true);
};

export const getIfNpiIsRegisteredAsPersonalOrPractice = (npiId: number, spinner: boolean, config: AxiosRequestConfig = {}): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/health/npi/${npiId}/is-registered`, config, spinner);
};

export const verifyEmail = (userId: number, code: string): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `public/verify-email/${userId}/${code}`, {}, { withCredentials: false }, false);
};
export const sendAllRequests = async (requests: [], showSpinner: boolean): Promise<AxiosResponse[]> => {
    return AxiosActions.all(requests, showSpinner);
};

export const getAllCountries = (config?: AxiosRequestConfig, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `public/countries`, { withCredentials: false, ...config }, spinner);
};

export const deleteInboundShipment = (id: number, config: any = {}, spinner = false): Promise<AxiosResponse> => {
    return AxiosActions.delete(getAxiosInstances().V2, `/shipment/inbound/${id}`, config, spinner);
};

export const getServerCurrentTime = (spinner = false, config: AxiosRequestConfig = {}) => {
    return AxiosActions.get(getAxiosInstances().V2, "public/timestamp", { ...config, withCredentials: false }, spinner);
};

export const getUrlFromShortCode = (spinner = false, config: AxiosRequestConfig = {}): Promise<AxiosResponse<string>> => {
    return AxiosActions.get(getAxiosInstances().V2, "/public/url-mapping", { ...config, withCredentials: false }, spinner);
};

export const cancelTaskDefinitionRecord = (
    dto: { ids: number[]; cancellationReason?: string },
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/task-definition-record/cancel`, dto, config, spinner);
};
